import ProducerDetailsCollections from './ProducerDetailsCollections';

export default ProducerDetailsCollections;
